import { Grid, CardHeader, CardContent, Box, TextField, FormControlLabel, Switch, MenuItem } from "@mui/material";
import { locationServices } from "../../../services/AllServices";
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormikProvider, useFormik } from "formik";
import errorHandler from "../../../utils/errorHandler";
import CardLayout from "../../../layouts/CardLayout";
import LoadingButton from "@mui/lab/LoadingButton";
import { toast } from "react-toastify";

function AddEditCitie() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const fetchTaskData = useCallback(async () => {
    if (id) {
      setLoading(true);
      try {
        const response = await locationServices.getByIdCities({ cityId: id , type:"dropdown"});
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    }
  }, [id]);

  const fetchCountries = useCallback(async () => {
    try {
      const response = await locationServices.getCountry();
      setCountries(response?.data?.data || []);
    } catch (error) {
      errorHandler(error);
    }
  }, []);

  const fetchStatesByCountry = async (countryId) => {
    try {
      const response = await locationServices.getState({ countryId , type:"dropdown"});
      setStates(response?.data?.data || []);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    fetchTaskData();
    fetchCountries();
  }, [fetchTaskData, fetchCountries]);

  useEffect(() => {
    if (data?.country) {
      fetchStatesByCountry(data.country);
    }
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      countryId: data?.country?._id || '',
      stateId:   data?.state?._id || '',
      //  && states.find((s) => s._id === data.state) ? data.state : "",
      name: data?.name || "",
      status: data?.status ?? true,
    },

    validate: (values) => {
      const errors = {};
      if (!values.name.trim()) {
        errors.name = "This field is required";
      }
      if (!values.countryId) {
        errors.countryId = "This field is required";
      }
      if (!values.stateId) {
        errors.stateId = "This field is required";
      }
      return errors;
    },

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          ...(id && { cityId: id }),
          countryId: values.countryId,
          stateId: values.stateId,
          name: values.name.trim(),
          status: values.status,
        };

        const response = id
          ? await locationServices.editCities(payload)
          : await locationServices.addCities(payload);

        toast.success(response?.data?.message);
        navigate(-1);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const { values, touched, errors, handleChange, handleSubmit, setFieldValue } = formik;

  // Show loader until form is ready (to prevent select out-of-range error)
  // const isReady = !id || (data && (!data.state || states.length));

  return (
    <Box>
      <CardLayout>
        <CardHeader title={`${id ? "Edit" : "Add"} City`} />
        <CardContent>
          {/* {isReady ? ( */}
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TextField
                      select
                      fullWidth
                      required
                      label="Select Country"
                      name="countryId"
                      value={values.countryId}
                      onChange={(e) => {
                        const selectedCountry = e.target.value;
                        setFieldValue("countryId", selectedCountry);
                        setFieldValue("stateId", "");
                        fetchStatesByCountry(selectedCountry);
                      }}
                      error={Boolean(touched.countryId && errors.countryId)}
                      helperText={touched.countryId && errors.countryId}
                    >
                      {countries.map((country) => (
                        <MenuItem key={country._id} value={country._id}>
                          {country.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      select
                      fullWidth
                      required
                      label="Select State"
                      name="stateId"
                      value={values.stateId}
                      onChange={handleChange}
                      error={Boolean(touched.stateId && errors.stateId)}
                      helperText={touched.stateId && errors.stateId}
                      disabled={!values.countryId}
                    >
                      {states.map((state) => (
                        <MenuItem key={state._id} value={state._id}>
                          {state.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="City Name"
                      required
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      error={Boolean(touched.name && errors.name)}
                      helperText={touched.name && errors.name}
                      inputProps={{ maxLength: 50 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={values.status}
                          onChange={(e) => setFieldValue("status", e.target.checked)}
                          name="status"
                          color="primary"
                        />
                      }
                      label="Status (Active)"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box mt={3}>
                      <LoadingButton
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        loading={loading}
                        disabled={loading}
                      >
                        {id ? "Update" : "Add"} City
                      </LoadingButton>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          {/* ) : (
            "Loading..."
          )} */}
        </CardContent>
      </CardLayout>
    </Box>
  );
}

export default AddEditCitie;
